import { render, staticRenderFns } from "./bindStoreAccount.vue?vue&type=template&id=40167755&scoped=true&"
import script from "./bindStoreAccount.vue?vue&type=script&lang=js&"
export * from "./bindStoreAccount.vue?vue&type=script&lang=js&"
import style0 from "./bindStoreAccount.vue?vue&type=style&index=0&id=40167755&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40167755",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40167755', component.options)
    } else {
      api.reload('40167755', component.options)
    }
    module.hot.accept("./bindStoreAccount.vue?vue&type=template&id=40167755&scoped=true&", function () {
      api.rerender('40167755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/bindStoreAccount.vue"
export default component.exports